export enum PanelNameE {
  Snapshot = 'snapshot',
  Trending = 'trending',
  Orders = 'orders',
  Favorites = 'favorites',
}
